module.exports = __webpack_public_path__ + "static/drone-c6376c472419acb1c89c9914fed28da2.jpg";